module.exports = __webpack_public_path__ + "media/images/icons/twotone/eye-0c0e30550696bd99c8f65e52fdc8b318.svg";